import { useState } from 'react'
import type { ModelRoute } from '../../logic/smartRouting.js'
import { GEMINI_MODELS } from '../../config/constants.js'
import { ROUTE_COLOR } from '../../components/chat/design-tokens.js'

const DEFAULT_ROUTE: ModelRoute = {
  id: GEMINI_MODELS.DEFAULT_FAST,
  label: 'READY',
  description: 'System initialized. Waiting for input.',
  color: ROUTE_COLOR.ready
}

export function useActiveRoute() {
  const [activeRoute, setActiveRoute] = useState<ModelRoute>(DEFAULT_ROUTE)
  return { activeRoute, setActiveRoute }
}
